<template>
  <div class="mx-4 mb-5" :style="isShareSession ? 'padding-top:64px;padding-left:10px':'' ">
    <div class="pb-0">
        <div class="mx-2 d-flex" style="justify-content: space-between;">
          <!-- style="padding:24px 0px 17px 5px " -->
        <h4 class="font-weight-bold" style="padding:0px !important" >Analytics</h4>
        <button v-if="!isShareSession && isAdminRole && $isHowuku" class="btn btn-outline-muted" @click="openShareLinkSettings() ">
          <font-awesome-icon v-if="!isPublicShare" icon="lock" class="mr-1"></font-awesome-icon>  
          <font-awesome-icon v-else icon="link" class="mr-1"></font-awesome-icon>  
          <span>Share Link</span>
        </button>
      </div>
      <!-- <div class="row pb-2 listing  " style="margin-bottom:-2px; border-radius:10px 10px 0px 0px" > -->
      <!-- <AirbnbDatePicker class="ml-3" style="top:-14px" module="dashboard"></AirbnbDatePicker> -->
      <div class="listing mt-3" style="width:100%;margin-bottom: -10px;border-radius: 10px 10px 0px 0px;box-shadow: rgb(0 0 0 / 8%) 0px -1px 10px;padding-bottom: 0px;">
      <div>
        <span
          class="custom-badge cursor-pointer custom-sizing"
          :class="{
            'badge-third': selectedTab === 1,
          }"
          @click="
          selectedTab = 1
          "
          >{{ t('Overview') }}</span
        >
        <span
          class="custom-badge cursor-pointer custom-sizing"
          :class="{
            'badge-third': selectedTab === 2,
          }"
          @click="
            selectedTab = 2
          "
          >{{ t('Visitors') }}</span
        >
        <!-- <span
          class="custom-badge cursor-pointer custom-sizing"
          :class="{
            'badge-third': selectedTab === 3,
          }"
          @click="
            selectedTab = 3
          "
          >{{ t('Behavior') }}</span
        >         -->
        <span
          class="custom-badge cursor-pointer custom-sizing"
          :class="{
            'badge-third': selectedTab === 4,
          }"
          @click="
            getLiveVisitorId()
            selectedTab = 4
          "
          ><div class="alive-dot mr-1"></div> <span class="fs-16 font-weight-bold">{{ liveCount }}</span> current visitors</span
        >        
        
      </div>
      <hr style="margin:24px -24px 12px -24px">
      <div class="row col-md-12">
        <div>
          <!-- <h5> 
             <span>{{ totalPageViewManual }} page views</span> 
          </h5> -->
          <div class="mb-2 d-inline-block" v-if="$route.query">
            <span
              v-for="(item, key) in $route.query"
              v-if="!['startDate', 'endDate'].includes(key)"
              v-bind:key="key"
              class="filter-tag no-drag text-muted2"
            >
              <span class="text-capitalize">{{ key }}</span>
              <b>{{ mapValue(key, item) || item.replace(/---/g, '/') }}</b>
              <div
                class="
                  cursor-pointer cursor-pointer
                  fs-16
                  d-inline-block
                  my-auto
                "
                @click="removeRouter(key)"
              >
                x
              </div>
            </span>
          </div>

          <span
            v-if="
              getRouteValue('datetime') ||
              getRouteValue('url') ||
              getRouteValue('referrer') ||
              getRouteValue('country') ||
              getRouteValue('utm_source') ||
              getRouteValue('utm_campaign') ||
              getRouteValue('utm_medium') ||
              getRouteValue('utm_term')
            "
            class="small cursor-pointer text-primary"
            @click="showAll()"
          >
            <span
              class="no-drag cursor-pointer text-capitalize text-muted2 fs-14"
              >clear filter</span
            >
          </span>
        </div>
      </div>
    </div>
    </div>
    <template>
      <!-- <div class="row">
        <div class="col-md-12">
          <h5>
             <span>{{ totalPageViewManual }} page views</span> 
          </h5>
          <div class="mb-4 d-inline-block" v-if="filterCriteria.length">
            <span
              v-for="(item, key) in filterCriteria"
              v-bind:key="key"
              class="filter-tag no-drag text-muted2"
            >
              <span class="text-capitalize">{{ getObjKey(item) }}:</span>
              <b>{{ mapValue(getObjKey(item), item[getObjKey(item)]) }}</b>
              <div
                class="
                  cursor-pointer cursor-pointer
                  fs-16
                  d-inline-block
                  my-auto
                "
                @click="removeRouter(getObjKey(item))"
              >
                x
              </div>
            </span>
          </div>

          <span
            v-if="
              getRouteValue('datetime') ||
              getRouteValue('url') ||
              getRouteValue('referrer') ||
              getRouteValue('country')
            "
            class="small cursor-pointer text-primary"
            @click="showAll()"
          >
            <span
              class="no-drag cursor-pointer text-capitalize text-muted2 fs-14"
              >clear filter</span
            >
          </span>
        </div>
      </div> -->
    </template>

    <div v-show="selectedTab === 1">
      <div class="listing mh-400-2 py-0" style="border-radius:0px 0px 10px 10px;box-shadow: rgb(0 0 0 / 8%) 0px 7px 10px;">

        <div class="row my-2">
          <div class="col-md-10">
            <div :key="previousIsLoaded" class="d-flex flex-md-row flex-column justify-content-between mt-2 px-4">
              <div class="flex-item px-0 mx-0">
                <p class="text-muted2 font-weight-bold mb-2 text-uppercase fs-12"
                  style="letter-spacing: 0.5px"
                >
                  {{ t('Total Sessions') }}
                </p>
                <div v-if="isLoaded">
                  <span
                    class="fs-30 h4 font-weight-bolder"
                    :rel="thousandFormat(pageview.unique)"
                    >{{ shortNumber(pageview.unique) }}</span
                  >

                  <CompareStat :previousNumber="previousunique"></CompareStat>
                </div>
                <div
                  v-else class="placeholder placeholder-heading w-25 mb-1"
                ></div>
              </div>
              <div class="flex-item px-0 mx-0">
                <p class="text-muted2 font-weight-bold mb-2 text-uppercase fs-12"
                  style="letter-spacing: 0.5px"
                >
                  {{ t('Total Pageviews') }}
                </p>
                <div v-if="isLoaded">
                  <span
                    class="fs-30 h4 font-weight-bolder"
                    :rel="thousandFormat(pageview.count)"
                    >{{ shortNumber(pageview.count) }}</span
                  >
                  <CompareStat :previousNumber="previouscount"></CompareStat>
                </div>
                <div
                  v-else class="placeholder placeholder-heading w-25 mb-1"
                ></div>
              </div>
              <div class="flex-item px-0 mx-0">
                <p class="text-muted2 font-weight-bold mb-2 text-uppercase fs-12"
                  style="letter-spacing: 0.5px"
                >
                  {{ t('Pages per Session') }}
                </p>
                <div v-if="isLoaded">
                  <span
                    class="fs-30 h4 font-weight-bolder"
                    :rel="thousandFormat(pageview.count/pageview.unique)"
                    >{{ shortNumber((pageview.count/pageview.unique).toFixed(2)) }}</span
                  >
                  <CompareStat :previousNumber="previouspps"></CompareStat>
                </div>
                <div
                  v-else class="placeholder placeholder-heading w-25 mb-1"
                ></div>
              </div>

              <div class="flex-item px-0 mx-0">
                <p class="text-muted2 font-weight-bold mb-2 text-uppercase fs-12"
                  style="letter-spacing: 0.5px"
                >
                  {{ t('Average session duration') }}
                </p>

                <div v-if="isLoaded">
                  <span class="fs-30 h4 font-weight-bolder">{{ sessionTime }}</span>
                  <CompareStat
                    :previousNumber="previousrawSessionTime"
                  ></CompareStat>
                </div>
                <div
                  v-else class="placeholder placeholder-heading w-25 mb-1"
                ></div>
              </div>
              <div class="flex-item px-0 mx-0">
                <p class="text-muted2 font-weight-bold mb-2 text-uppercase fs-12"
                  style="letter-spacing: 0.5px"
                >
                  {{ t('Average Bounce Rate') }}
                </p>

                <div v-if="isLoaded">
                  <span class="fs-30 h4 font-weight-bolder">{{ bounce }}%</span>
                  <CompareStat
                    :previousNumber="previousbounce"
                    :opposite="true"
                  ></CompareStat>
                </div>
                <div
                  v-else class="placeholder placeholder-heading w-25 mb-1"
                ></div>
              </div>
            </div>
          </div>
          <div class="col-md-2 ml-auto text-right">
            <!-- <button
              v-if="isLoaded"
              class="btn btn-link text-muted"
              @click="downloadPdf()"
            >
              <font-awesome-icon icon="download" class="fa-sm mr-1" /> Download
              PDF
            </button> -->

            <button
              style="position: relative"
              v-if="isLoaded"
              class="btn d-inline-block mb-2"
              @click="(!isShareSession) ? exportCsv() : ''"
              v-bind:class="{
                'btn-light': isSharedSession ||
                  (!$isFreePlan.includes($session.get('paid_plan')) &&
                   !$isLegacyFreePlan.includes($session.get('paid_plan'))),
                'btn-muted text-muted': !isSharedSession &&
                  ($isFreePlan.includes($session.get('paid_plan')) ||
                   $isLegacyFreePlan.includes($session.get('paid_plan')))
              }"
              >
              <font-awesome-icon
                v-if="
                  $isFreePlan.includes($session.get('paid_plan')) ||
                  $isLegacyFreePlan.includes($session.get('paid_plan'))
                "
                class="fa-lg new-upgrade-icon"
                icon="arrow-circle-up"
                color="#ff7d66"
              />
              <font-awesome-icon icon="download" class="fa-sm mr-1" /> Export to
              CSV
            </button>
            <div class="mt-2 btn-group-custom">
              <div class="item-btn"  v-bind:class="{ active: chartType === 'line' }"><span class="chart-type tooltip-pop" style="border-bottom:0px;" :rel="t('Change to line chart')" @click="chartType = 'line';key++"><font-awesome-icon class="fa-md" icon="chart-line"/></span></div>
              <div class="item-btn"  v-bind:class="{ active: chartType === 'bar' }"><span class="chart-type tooltip-pop" style="border-bottom:0px;" :rel="t('Change to bar chart')" @click="chartType = 'bar';key++"><font-awesome-icon class="fa-md" icon="chart-bar"/></span></div>
            </div>              
          </div>
          <!-- <div class="col-md-12">{{ this.previousInterval }}</div> -->
        </div>
        <div class="row mx-1 pb-0">
          <div class="col-xs-12 col-md-12 col-lg-12">
            <div class="box fixed-200h mx-2" id="linebox">
              <template v-if="isLoaded">
                <div class="box-content" :key="key">
                  <PageviewBarChart
                    :referrer="getRouteValue('referrer')"
                    :url="getRouteValue('url')"
                    :country="getRouteValue('country')"
                    :utm_source="getRouteValue('utm_source')"
                    :utm_campaign="getRouteValue('utm_campaign')"
                    :utm_medium="getRouteValue('utm_medium')"
                    :utm_term="getRouteValue('utm_term')"
                    :tz="tz"
                    name="pageview"
                    groupby="date"
                    mapUnit="dateFormat"
                    :chartType="chartType"
                    :data="chartData"
                    :dataPrevious="chartDataPrevious"
                    @total="getPageview"
                    @searchtime="triggerTime"
                  ></PageviewBarChart>
                </div>              
              </template>
              <template v-else>
                <div class="row">
                  <div class="col-md-1">
                    <div
                      class="mb-0 align-bottom placeholder placeholder-hero"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 70px; height: calc(100% - 70px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 80px; height: calc(100% - 80px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 90px; height: calc(100% - 90px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 50px; height: calc(100% - 50px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 50px; height: calc(100% - 50px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 50px; height: calc(100% - 50px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="placeholder placeholder-hero"
                      style="margin-top: 90px; height: calc(100% - 90px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 80px; height: calc(100% - 80px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 20px; height: calc(100% - 20px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 40px; height: calc(100% - 40px)"
                    ></div>
                  </div>
                  <div class="col-md-1">
                    <div
                      class="align-bottom placeholder placeholder-hero"
                      style="margin-top: 50px; height: calc(100% - 50px)"
                    ></div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="row box mt-4" :key="statsRefresh">
        <div class="col-lg-12 col-xl-6 pb-4">        
          <div class="listing mh-400 p-0">
            <p class="box-title font-weight-bold p-4 mb-0">Top Sources

              <span
                class="text-muted font-weight-normal float-right cursor-pointer"
              >
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="sourceSelection = 1"
                  v-bind:class="{
                    'badge-third': sourceSelection === 1,
                  }">Website</a>
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="sourceSelection = 2"
                  v-bind:class="{
                    'badge-third': sourceSelection === 2,
                  }">Source</a>
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="sourceSelection = 3"
                  v-bind:class="{
                    'badge-third': sourceSelection === 3,
                  }">Campaign</a>
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="sourceSelection = 4"
                  v-bind:class="{
                    'badge-third': sourceSelection === 4,
                  }">Medium</a>   
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="sourceSelection = 5"
                  v-bind:class="{
                    'badge-third': sourceSelection === 5,
                  }">Term</a>                                
              </span>

            </p>
            <div class="table-responsive" v-if="sourceSelection === 1">
              <table class="table">
                <thead>
                  <tr>
                    <th>URL</th>
                    <th class="text-right">Pageviews</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="isLoaded">
                    <tr
                      v-for="(item, key) in top['referrer']" v-bind:key="key"
                      class="cursor-pointer" v-show="key < limit.referrer"
                      @click="showRefs(removeProtocol(item.referrer))"
                    >
                      <td class="w-75 p-1">
                        <div class="poll-background mb-1 position-relative p-2 fw-500"
                        :style="'width: ' + item.bar + '% !important'"
                      >
                        <span class="cursor-pointer hyperlink">
                          <span>
                            <img class="mr-1" v-if="item.referrer !== 'Direct'" width="16px" height="16px" :src="'https://api.faviconkit.com/' + item.link + '/16'" />
                            <img class="mr-1" v-else-if="item.referrer === 'Direct'" width="16px" height="16px" src="../assets/img/link.png" />
                            {{ shorten(removeProtocol(item.referrer), 50) }}
                          </span>
                        </span>
                      </div>
                      </td>

                      <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                        <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="index in 4" :key="index">
                      <td class="w-75">
                        <div class="placeholder placeholder-sentence mb-1" :style="'width: ' + Number(100 / index) + '%'"></div>
                      </td>
                      <td
                        class="text-right font-weight-bold small text-muted2 my-auto align-middle"
                      >
                        <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <div class="d-block text-center">
                <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                  v-if="top['referrer'].length > limit.referrer"
                  @click="limit.referrer += 5"
                  v-translate
                >
                  <span class="a-link">Show more</span>
                </p>              
              </div>
            </div>
            <div class="table-responsive" v-if="[2,3,4,5].includes(sourceSelection)">
              <table class="table">
                <thead>
                  <tr>
                    <th>URL</th>
                    <th class="text-right">Pageviews</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="isLoaded">
                    <tr
                      v-for="(item, key) in top[mapUtmTag[sourceSelection]]" v-bind:key="key"
                      class="cursor-pointer" v-show="key < limit[mapUtmTag[sourceSelection]]"
                      @click="showUtm(mapUtmTag[sourceSelection], removeProtocol(item[mapUtmTag[sourceSelection]]))"
                    >
                      <td class="w-75 p-1">
                        <div class="poll-background mb-1 position-relative p-2 fw-500"
                        :style="'width: ' + item.bar + '% !important'"
                      >
                        <span class="cursor-pointer hyperlink">
                          <span>
                            {{ shorten(removeProtocol(item[mapUtmTag[sourceSelection]]), 50) }}
                          </span>
                        </span>
                      </div>
                      </td>

                      <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                        <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr v-for="index in 4" :key="index">
                      <td class="w-75">
                        <div class="placeholder placeholder-sentence mb-1" :style="'width: ' + Number(100 / index) + '%'"></div>
                      </td>
                      <td
                        class="text-right font-weight-bold small text-muted2 my-auto align-middle"
                      >
                        <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <div class="d-block text-center">
                <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                  v-if="top[mapUtmTag[sourceSelection]].length > limit[mapUtmTag[sourceSelection]]"
                  @click="limit[mapUtmTag[sourceSelection]] += 5"
                  v-translate
                >
                  <span class="a-link">Show more</span>
                </p>              
              </div>
            </div>            
          </div> 
        </div> 

        <div class="col-lg-12 col-xl-6 pb-4">
          <div class="listing mh-400 p-0">
            <p class="box-title font-weight-bold p-4 mb-0">
              Top pages

              <span
                class="text-muted font-weight-normal float-right cursor-pointer"
              >
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="pageSelection = 1"
                  v-bind:class="{
                    'badge-third': pageSelection === 1,
                  }">Pages</a>
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="pageSelection = 2"
                  v-bind:class="{
                    'badge-third': pageSelection === 2,
                  }">Entry</a>
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="pageSelection = 3"
                  v-bind:class="{
                    'badge-third': pageSelection === 3,
                  }">Exit</a>
              </span>
            </p>
            <template v-if="isLoaded && pageSelection === 1">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>URL</th>
                      <th class="text-right">Pageviews</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="isLoaded">
                      <tr
                      v-for="(item, key) in top['destination']" v-bind:key="key"
                        class="cursor-pointer" v-show="key < limit.destination"
                        @click="showUrl(getDomain(item.destination))"
                      >
                        <td class="w-75 p-1">
                          <div class="poll-background mb-1 position-relative p-2 fw-500"
                          :style="'width: ' + item.bar + '% !important'"
                        >
                          <span class="cursor-pointer hyperlink">
                            <span>{{
                              shorten(item.destinationDisplay, 50)
                            }}</span>
                          </span>
                        </div>
                        </td>

                        <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                          <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr v-for="index in 4" :key="index">
                        <td class="w-75">
                          <div class="placeholder placeholder-sentence mb-1" :style="'width: ' + Number(100 / index) + '%'"></div>
                        </td>
                        <td
                          class="text-right font-weight-bold small text-muted2 my-auto align-middle"
                        >
                          <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div class="d-block text-center">
                  <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                    v-if="top['destination'].length > limit.destination"
                    @click="limit.destination += 5"
                    v-translate
                  >
                    <span class="a-link">Show more</span>
                  </p>              
                </div>
              </div> 
            </template>
            <template v-else-if="isLoaded && pageSelection === 2">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>URL</th>
                      <th class="text-right">Pageviews</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="isLoaded">
                      <tr
                      v-for="(item, key) in top['entry']" v-bind:key="key"
                        class="cursor-pointer" v-show="key < limit.entry"
                        @click="showUrl(getDomain(item.entry))"
                      >
                        <td class="w-75 p-1">
                          <div class="poll-background mb-1 position-relative p-2 fw-500"
                          :style="'width: ' + item.bar + '% !important'"
                        >
                          <span class="cursor-pointer hyperlink">
                            <span>{{ shorten(item.entryDisplay, 50) }}</span>
                          </span>
                        </div>
                        </td>

                        <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                          <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div class="d-block text-center">
                  <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                    v-if="top['entry'].length > limit.entry"
                    @click="limit.entry += 5"
                    v-translate
                  >
                    <span class="a-link">Show more</span>
                  </p>              
                </div>
              </div> 
            </template>
            <template v-else-if="isLoaded && pageSelection === 3">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>URL</th>
                      <th class="text-right">Pageviews</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="isLoaded">
                      <tr
                      v-for="(item, key) in top['exit']" v-bind:key="key"
                        class="cursor-pointer" v-show="key < limit.exit"
                        @click="showUrl(getDomain(item.exit))"
                      >
                        <td class="w-75 p-1">
                          <div class="poll-background mb-1 position-relative p-2 fw-500"
                          :style="'width: ' + item.bar + '% !important'"
                        >
                          <span class="cursor-pointer hyperlink">
                            <span>{{ shorten(item.exitDisplay, 50) }}</span>
                          </span>
                        </div>
                        </td>

                        <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                          <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr v-for="index in 4" :key="index">
                        <td class="w-75">
                          <div class="placeholder placeholder-sentence mb-1" :style="'width: ' + Number(100 / index) + '%'"></div>
                        </td>
                        <td
                          class="text-right font-weight-bold small text-muted2 my-auto align-middle"
                        >
                          <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div class="d-block text-center">
                  <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                    v-if="top['exit'].length > limit.exit"
                    @click="limit.exit += 5"
                    v-translate
                  >
                    <span class="a-link">Show more</span>
                  </p>              
                </div>
              </div> 
            </template>
            <template v-else>
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>URL</th>
                      <th class="text-right">Pageviews</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="index in 4" :key="index">
                      <td class="w-75">
                        <div class="placeholder placeholder-sentence mb-1" :style="'width: ' + Number(100 / index) + '%'"></div>
                      </td>
                      <td
                        class="text-right font-weight-bold small text-muted2 my-auto align-middle"
                      >
                        <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                      </td>
                    </tr>
                  </tbody>   
                </table>
              </div>           
            </template>
          </div>
        </div>

        <div class="col-lg-12 col-xl-6 pb-4">
          <div class="listing mh-400 p-0">
            <p class="box-title font-weight-bold p-4 mb-0">
              {{ t('Locations') }}
              <span
                class="text-muted font-weight-normal float-right cursor-pointer"
              >
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="locationSelection = 1"
                  v-bind:class="{
                    'badge-third':
                      locationSelection === 1,
                  }">Country</a>
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="locationSelection = 2"
                  v-bind:class="{
                    'badge-third':
                      locationSelection === 2,
                  }">City</a>
              </span>
            </p>
            <!-- <p v-if="isBlurred" class="small text-muted2">
              Subscribe to any of Howuku paid plan see visitor's country.
              <br />
              <router-link
                class="cursor-pointer text-primary"
                to="/subscription"
                >Upgrade account</router-link
              >
            </p> -->
            <!-- <div
              v-blur="{
                isBlurred: isBlurred,
                opacity: 1,
                filter: 'blur(10px)',
                transition: 'all .3s linear',
              }"
              v-bind:class="{ blockInteraction: isBlurred }"
              :style="isBlurred ? 'pointer-events: none;' : ''"
            > -->
            <div>
              <template v-if="isLoaded && locationSelection === 1">

                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th class="text-right">Pageviews</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="isLoaded">
                        <tr
                        v-for="(item, key) in top['country']" v-bind:key="key"
                          class="cursor-pointer" v-show="key < limit.country"
                          @click="showCountry(item.country)"
                        >
                          <td class="w-75 p-1">
                            <div class="poll-background mb-1 position-relative p-2 fw-500"
                            :style="'width: ' + item.bar + '% !important'"
                          >
                          <span class="cursor-pointer hyperlink">
                              <img
                                class="mr-1 flag-rounded"
                                v-if="item.country_code"
                                :src="`https://flagicons.lipis.dev/flags/1x1/${item.country_code.toString().toLowerCase()}.svg`"
                                width="20px" height="20px"
                              />
                              {{
                                conceal(shorten(removeProtocol(item.country), 25))
                              }}
                            </span>
                          </div>
                          </td>

                          <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                            <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div class="d-block text-center">
                    <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                      v-if="top['country'].length > limit.country"
                      @click="limit.country += 5"
                      v-translate
                    >
                      <span class="a-link">Show more</span>
                    </p>              
                  </div>
                </div> 
              </template>
              <template v-else-if="isLoaded && locationSelection === 2">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th class="text-right">Pageviews</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="isLoaded">
                        <tr
                        v-for="(item, key) in top['city']" v-bind:key="key"
                          class="cursor-pointer" v-show="key < limit.city"
                          @click="showCity(item.city)"
                        >
                          <td class="w-75 p-1">
                            <div class="poll-background mb-1 position-relative p-2 fw-500"
                            :style="'width: ' + item.bar + '% !important'"
                          >
                            <span class="cursor-pointer hyperlink">
                              <img
                                class="mr-1 flag-rounded"
                                v-if="item.country_code"
                                :src="`https://flagicons.lipis.dev/flags/1x1/${item.country_code.toString().toLowerCase()}.svg`"
                                width="20px" height="20px"
                              />
                              {{
                                conceal(shorten(removeProtocol(item.city), 25))
                              }}
                            </span>
                          </div>
                          </td>

                          <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                            <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div class="d-block text-center">
                    <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                      v-if="top['city'].length > limit.city"
                      @click="limit.city += 5"
                      v-translate
                    >
                      <span class="a-link">Show more</span>
                    </p>              
                  </div>
                </div> 
              </template>
              <template v-else>
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th class="text-right">Pageviews</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="index in 4" :key="index">
                        <td class="w-75">
                          <div class="placeholder placeholder-sentence mb-1" :style="'width: ' + Number(100 / index) + '%'"></div>
                        </td>
                        <td
                          class="text-right font-weight-bold small text-muted2 my-auto align-middle"
                        >
                          <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                        </td>
                      </tr>
                    </tbody>   
                  </table>
                </div>           
              </template>
            </div>
          </div>
        </div>

        <div class="col-lg-12 col-xl-6 pb-4">
          <div class="listing mh-400 p-0">
            <p class="box-title font-weight-bold p-4 mb-0">
              {{ t('Technologies') }}

              <span
                class="text-muted font-weight-normal float-right cursor-pointer"
              >
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="deviceSelection = 1"
                  v-bind:class="{
                    'badge-third':
                      deviceSelection === 1,
                  }">Device</a>
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="deviceSelection = 2"
                  v-bind:class="{
                    'badge-third':
                      deviceSelection === 2,
                  }">Browser</a>
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="deviceSelection = 3"
                  v-bind:class="{
                    'badge-third':
                      deviceSelection === 3,
                  }">OS</a>
                <a class="custom-badge cursor-pointer custom-sizing"
                  @click="deviceSelection = 4"
                  v-bind:class="{
                    'badge-third':
                      deviceSelection === 4,
                  }">Size</a>
              </span>
            </p>
            <!-- <p v-if="isBlurred" class="small text-muted2">
              Subscribe to any of Howuku paid plan see visitor's device.
              <br />
              <router-link
                class="cursor-pointer text-primary"
                to="/subscription"
                >Upgrade account</router-link
              >
            </p> -->
            <!-- <div
              v-blur="{
                isBlurred: isBlurred,
                opacity: 1,
                filter: 'blur(10px)',
                transition: 'all .3s linear',
              }"
              v-bind:class="{ blockInteraction: isBlurred }"
              :style="isBlurred ? 'pointer-events: none;' : ''"
            > -->
            <div>
              <template v-if="isLoaded && deviceSelection === 1">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th class="text-right">Pageviews</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="isLoaded">
                        <tr
                        v-for="(item, key) in top['device']" v-bind:key="key"
                          class="cursor-pointer" v-show="key < limit.device"
                          @click="showDevice(item.device)"
                        >
                          <td class="w-75 p-1">
                            <div class="poll-background mb-1 position-relative p-2 fw-500"
                            :style="'width: ' + item.bar + '% !important'"
                          >
                            <span class="cursor-pointer hyperlink">
                              <font-awesome-icon
                                class="mr-1 text-muted"
                                :icon="
                                  item.device === 1
                                    ? 'desktop'
                                    : item.device === 2
                                    ? 'mobile-alt'
                                    : 'tablet-alt'
                                "
                              ></font-awesome-icon>
                              {{
                                item.device === 1
                                  ? 'Desktop'
                                  : item.device === 2
                                  ? '   Mobile'
                                  : 'Tablet'
                              }}
                            </span>
                          </div>
                          </td>

                          <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                            <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div class="d-block text-center">
                    <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                      v-if="top['device'].length > limit.device"
                      @click="limit.device += 5"
                      v-translate
                    >
                      <span class="a-link">Show more</span>
                    </p>              
                  </div>
                </div> 
              </template>
              <template v-else-if="isLoaded && deviceSelection === 2">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th class="text-right">Pageviews</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="isLoaded">
                        <tr
                        v-for="(item, key) in top['browser']" v-bind:key="key"
                          class="cursor-pointer" v-show="key < limit.browser"
                          @click="showBrowser(item.browser)"
                        >
                          <td class="w-75 p-1">
                            <div class="poll-background mb-1 position-relative p-2 fw-500"
                            :style="'width: ' + item.bar + '% !important'"
                          >
                            <span class="cursor-pointer hyperlink">
                              <font-awesome-icon
                                class="mr-1 text-muted"
                                :icon="[
                                  'fab',
                                  item.browser === 'Internet Explorer'
                                    ? 'internet-explorer'
                                    : item.browser.toLowerCase(),
                                ]"
                              ></font-awesome-icon>
                              {{ item.browser }}
                            </span>
                          </div>
                          </td>

                          <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                            <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div class="d-block text-center">
                    <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                      v-if="top['browser'].length > limit.browser"
                      @click="limit.browser += 5"
                      v-translate
                    >
                      <span class="a-link">Show more</span>
                    </p>              
                  </div>
                </div> 
              </template>
              <template v-else-if="isLoaded && deviceSelection === 3">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th class="text-right">Pageviews</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="isLoaded">
                        <tr
                        v-for="(item, key) in top['os']" v-bind:key="key"
                          class="cursor-pointer" v-show="key < limit.os"
                          @click="showOS(item.os)"
                        >
                          <td class="w-75 p-1">
                            <div class="poll-background mb-1 position-relative p-2 fw-500"
                            :style="'width: ' + item.bar + '% !important'"
                          >
                            <span class="cursor-pointer hyperlink">
                              <font-awesome-icon
                                class="mr-1 text-muted"
                                :icon="
                                  item.os === 'Windows'
                                    ? ['fab', 'windows']
                                    : item.os === 'MacOS' || item.os === 'iOS'
                                    ? ['fab', 'apple']
                                    : item.os === 'Android'
                                    ? ['fab', 'android']
                                    : item.os === 'Linux'
                                    ? ['fab', 'linux']
                                    : 'question-circle'
                                "
                              ></font-awesome-icon>
                              {{ item.os }}
                            </span>
                          </div>
                          </td>

                          <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                            <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div class="d-block text-center">
                    <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                      v-if="top['os'].length > limit.os"
                      @click="limit.os += 5"
                      v-translate
                    >
                      <span class="a-link">Show more</span>
                    </p>              
                  </div>
                </div> 
              </template>
              <template v-else-if="isLoaded && deviceSelection === 4">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th class="text-right">Pageviews</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="isLoaded">
                        <tr
                        v-for="(item, key) in top['resolution']" v-bind:key="key"
                          class="cursor-pointer" v-show="key < limit.resolution"
                          @click="showResolution(item.resolution)"
                        >
                          <td class="w-75 p-1">
                            <div class="poll-background mb-1 position-relative p-2 fw-500"
                            :style="'width: ' + item.bar + '% !important'"
                          >
                            <span class="cursor-pointer hyperlink">
                              <font-awesome-icon
                                class="mr-1 text-muted"
                                :icon="estimatedDevice(item.resolution)"
                              ></font-awesome-icon>
                              {{ item.resolution }}
                            </span>
                          </div>
                          </td>

                          <td class="text-right font-weight-bold small text-muted2 my-auto align-middle">
                            <span class="font-weight-bold">{{shortNumber(item.count)}}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <div class="d-block text-center">
                    <p class="cursor-pointer text-muted my-3 text-center btn btn-blank mx-auto py-2 fs-14"
                      v-if="top['os'].length > limit.resolution"
                      @click="limit.resolution += 5"
                      v-translate
                    >
                      <span class="a-link">Show more</span>
                    </p>              
                  </div>
                </div> 
              </template>
              <template v-else>
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>URL</th>
                        <th class="text-right">Pageviews</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="index in 4" :key="index">
                        <td class="w-75">
                          <div class="placeholder placeholder-sentence mb-1" :style="'width: ' + Number(100 / index) + '%'"></div>
                        </td>
                        <td
                          class="text-right font-weight-bold small text-muted2 my-auto align-middle"
                        >
                          <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                        </td>
                      </tr>
                    </tbody>   
                  </table>
                </div>           
              </template>
            </div>
          </div>
        </div>
        <!--
        <div
          class="listing col-lg-12 col-xl-6 pb-4"
          v-show="!getRouteValue('resolution') && top['resolution'].length"
        >
          <p class="box-title font-weight-bold">
            {{ t('Screen size') }}
          </p>
          <p v-if="isBlurred" class="small text-muted2">
            Subscribe to any of Howuku paid plan see visitor's resolution.
            <br />
            <router-link class="cursor-pointer text-primary" to="/subscription"
              >Upgrade account</router-link
            >
          </p>
          <div
            v-blur="{
              isBlurred: isBlurred,
              opacity: 1,
              filter: 'blur(10px)',
              transition: 'all .3s linear',
            }"
            v-bind:class="{ blockInteraction: isBlurred }"
            :style="isBlurred ? 'pointer-events: none;' : ''"
          >
            <template v-if="isLoaded">
              <div
                v-for="(item, key) in top['resolution']"
                v-bind:key="key"
                class="pr-4"
              >
                <div v-show="key < limit.resolution">
                  <div class="row">
                    <div class="col-md-10">
                      <div
                        class="poll-background mb-1 position-relative p-2 fw-500"
                        :style="'width: ' + item.bar + '% !important'"
                      >
                        <span
                          class="cursor-pointer hyperlink"
                          @click="showResolution(item.resolution)"
                        >
                          <font-awesome-icon
                            class="mr-1 text-muted"
                            :icon="estimatedDevice(item.resolution)"
                          ></font-awesome-icon>
                          {{ item.resolution }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="col-md-2 ml-auto py-2 px-0 text-right text-muted"
                    >
                      <span class="font-weight-bold">{{
                        shortNumber(item.count)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <p
                class="
                  cursor-pointer
                  text-uppercase text-muted
                  fs-14
                  font-weight-600
                  my-3
                "
                v-if="top['resolution'].length > limit.resolution"
                @click="limit.resolution += 5"
                v-translate
              >
                <span class="a-link">Show more</span>
              </p>
            </template>
            <template v-else>
              <div
                class="placeholder placeholder-sentence w-75"
                style="height: 30px"
              ></div>
              <div
                class="placeholder placeholder-sentence w-75"
                style="height: 30px"
              ></div>
              <div
                class="placeholder placeholder-sentence w-50"
                style="height: 30px"
              ></div>
              <div
                class="placeholder placeholder-sentence w-25"
                style="height: 30px"
              ></div>
            </template>
          </div>
        </div> -->

        <!-- <div
          class="listing col-lg-12 col-xl-6 pb-4"
          v-show="!getRouteValue('browser') && top['browser'].length"
        >
          <p class="box-title font-weight-bold">
            {{ t('Internet Browser') }}
          </p>
          <p v-if="isBlurred" class="small text-muted2">
            Subscribe to any of Howuku paid plan see visitor's browser.
            <br />
            <router-link class="cursor-pointer text-primary" to="/subscription"
              >Upgrade account</router-link
            >
          </p>
          <div
            v-blur="{
              isBlurred: isBlurred,
              opacity: 1,
              filter: 'blur(10px)',
              transition: 'all .3s linear',
            }"
            v-bind:class="{ blockInteraction: isBlurred }"
            :style="isBlurred ? 'pointer-events: none;' : ''"
          >
            <template v-if="isLoaded">
              <div
                v-for="(item, key) in top['browser']"
                v-bind:key="key"
                class="pr-4"
              >
                <div v-show="key < limit.browser">
                  <div class="row">
                    <div class="col-md-10">
                      <div
                        class="poll-background mb-1 position-relative p-2 fw-500"
                        :style="'width: ' + item.bar + '% !important'"
                      >
                        <span
                          class="cursor-pointer hyperlink"
                          @click="showBrowser(item.browser)"
                        >
                          <font-awesome-icon
                            class="mr-1 text-muted"
                            :icon="[
                              'fab',
                              item.browser === 'Internet Explorer'
                                ? 'internet-explorer'
                                : item.browser.toLowerCase(),
                            ]"
                          ></font-awesome-icon>
                          {{ item.browser }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="col-md-2 ml-auto py-2 px-0 text-right text-muted"
                    >
                      <span class="font-weight-bold">{{
                        shortNumber(item.count)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <p
                class="
                  cursor-pointer
                  text-uppercase text-muted
                  fs-14
                  font-weight-600
                  my-3
                "
                v-if="top['browser'].length > limit.browser"
                @click="limit.browser += 5"
                v-translate
              >
                <span class="a-link">Show more</span>
              </p>
            </template>
            <template v-else>
              <div
                class="placeholder placeholder-sentence w-75"
                style="height: 30px"
              ></div>
              <div
                class="placeholder placeholder-sentence w-75"
                style="height: 30px"
              ></div>
              <div
                class="placeholder placeholder-sentence w-50"
                style="height: 30px"
              ></div>
              <div
                class="placeholder placeholder-sentence w-25"
                style="height: 30px"
              ></div>
            </template>
          </div>
        </div> -->

        <!-- <div
          class="listing col-lg-12 col-xl-6 pb-4"
          v-show="!getRouteValue('os') && top['os'].length"
        >
          <p class="box-title font-weight-bold">
            {{ t('Operating System') }}
          </p>
          <p v-if="isBlurred" class="small text-muted2">
            Subscribe to any of Howuku paid plan see visitor's operating system.
            <br />
            <router-link class="cursor-pointer text-primary" to="/subscription"
              >Upgrade account</router-link
            >
          </p>
          <div
            v-blur="{
              isBlurred: isBlurred,
              opacity: 1,
              filter: 'blur(10px)',
              transition: 'all .3s linear',
            }"
            v-bind:class="{ blockInteraction: isBlurred }"
            :style="isBlurred ? 'pointer-events: none;' : ''"
          >
            <template v-if="isLoaded">
              <div
                v-for="(item, key) in top['os']"
                v-bind:key="key"
                class="pr-4"
              >
                <div v-show="key < limit.os">
                  <div class="row">
                    <div class="col-md-10">
                      <div
                        class="poll-background mb-1 position-relative p-2 fw-500"
                        :style="'width: ' + item.bar + '% !important'"
                      >
                        <span
                          class="cursor-pointer hyperlink"
                          @click="showOS(item.os)"
                        >
                          <font-awesome-icon
                            class="mr-1 text-muted"
                            :icon="
                              item.os === 'Windows'
                                ? ['fab', 'windows']
                                : item.os === 'MacOS' || item.os === 'iOS'
                                ? ['fab', 'apple']
                                : item.os === 'Android'
                                ? ['fab', 'android']
                                : item.os === 'Linux'
                                ? ['fab', 'linux']
                                : 'question-circle'
                            "
                          ></font-awesome-icon>
                          {{ item.os }}
                        </span>
                      </div>
                    </div>
                    <div
                      class="col-md-2 ml-auto py-2 px-0 text-right text-muted"
                    >
                      <span class="font-weight-bold">{{
                        shortNumber(item.count)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <p
                class="
                  cursor-pointer
                  text-uppercase text-muted
                  fs-14
                  font-weight-600
                  my-3
                "
                v-if="top['os'].length > limit.os"
                @click="limit.os += 5"
                v-translate
              >
                <span class="a-link">Show more</span>
              </p>
            </template>
            <template v-else>
              <div
                class="placeholder placeholder-sentence w-75"
                style="height: 30px"
              ></div>
              <div
                class="placeholder placeholder-sentence w-75"
                style="height: 30px"
              ></div>
              <div
                class="placeholder placeholder-sentence w-50"
                style="height: 30px"
              ></div>
              <div
                class="placeholder placeholder-sentence w-25"
                style="height: 30px"
              ></div>
            </template>
          </div>
        </div> -->
      </div>
    </div>

    <div v-show="selectedTab === 2">
      <Contact
        :key="JSON.stringify(visitorIds)"
        :visitorIds="visitorIds"
      ></Contact>
    </div>

    <div v-show="selectedTab === 4">
      <Contact
        :key="JSON.stringify(liveVisitorIds)"
        :visitorIds="liveVisitorIds"
      ></Contact>
    </div>    
    <modal style="z-index: 10000" class="to-right full-modal" name="show-shareSettings" width="500px" height="100%" :adaptive="true">
      <shareSettings @permissionChanged="checkForFlag()">
      </shareSettings>
    </modal>
    <!-- <div v-show="selectedTab === 3">
      <BehaviorFlow></BehaviorFlow>
    </div>     -->
  </div>
</template>

<script>
import { store } from '@/store'
import moment from 'moment'
import PageviewBarChart from '@/components/Dashboard/PageviewBarChart.vue'
const AirbnbDatePicker = () => import('@/components/AirbnbDatePicker.vue')
import CompareStat from '@/components/CompareStat.vue'
const Contact = () => import('@/pages/Contact.vue')
import BehaviorFlow from './BehaviorFlow.vue'
const shareSettings = () => import('@/pages/shareSetting.vue')

export default {
  beforeRouteUpdate(to, from, next) {
    setTimeout(() => {
      this.key++
      this.loadStats()
    }, 100);
    this.setupRoute()
    next();
  },  
  components: {
    PageviewBarChart,
    AirbnbDatePicker,
    Contact,
    CompareStat,
    BehaviorFlow,
    shareSettings
},
  store,
  data: function () {
    return {
      selectedTab: 1,
      mapUtmTag: {
        2: 'utm_source',
        3: 'utm_campaign',
        4: 'utm_medium',
        5: 'utm_term'
      },
      chartType: 'line',
      checkAlive: null,
      liveData: null,
      liveCount: 0,
      sourceSelection: 1,
      pageSelection: 1,
      deviceSelection: 1,
      locationSelection: 1,
      chartData: null,
      chartDataPrevious: null,
      statsRefresh: 0,
      previousInterval: 0,
      previousunique: 0,
      previouscount: 0,
      previewpps: 0,
      previousrawSessionTime: 0,
      previousbounce: 0,
      noData: true,
      visitor: {},
      showChart: false,
      pageview: {
        count: 0,
        visitor: 0,
        unique: 0,
        rawSessionTime: 0
      },
      bounce: 0,
      sessionTime: 0,
      previous: {
        count: 0,
        visitor: 0,
        unique: 0,
        bounce: 0,
        rawSessionTime: 0
      },
      company_id: this.$session.get('company_id'),
      stats: {},
      startDate: '',
      endDate: '',
      isLoaded: false,
      previousIsLoaded: false,
      isBlurred: false,
      key: 0,
      url: null,
      totalPageview: 0,
      totalPageViewManual: 0,
      top: {
        entry: 0,
        exit: 0,
        referrer: 0,
        destination: 0,
        country: 0,
        city: 0,
        resolution: 0,
        device: 0,
        browser: 0,
        os: 0,
        utm_source: 0,
        utm_campaign: 0,
        utm_medium: 0,
        utm_term: 0,
      },
      limit: {
        entry: 7,
        exit: 7,
        referrer: 7,
        country: 7,
        city: 7,
        destination: 7,
        resolution: 7,
        device: 7,
        browser: 7,
        os: 7,
        utm_source: 7,
        utm_campaign: 7,
        utm_medium: 7,
        utm_term: 7,
      },
      visitorIds: [],
      liveVisitorIds: [],
      filterCriteria: [],
      tz: '',
      tempWidgetId:0,
      tempjwt:'',
      encryptedString: null,
      secretPosition: 17,
      isShareSession:false,
      isPublicShare:false,
      isAdminRole : this.$session.get('role') !== 3 && this.$session.get('role') !== 2,
      statInProgress: false,
      previousStatInProgress: false,
    }
  },
  beforeMount() {
    this.assignValuesForShare()
    if(!this.$route.params.encryptedParam){
      this.checkForFlag()
    }
  },
  mounted() {
    this.loadStats()
    if (!this.pageview.count) this.noData = true

    clearInterval(this.checkAlive)
    this.checkAlive = setInterval(() => {
      this.$http.get(process.env.API_ENDPOINT + '/current/live',{  
        headers: {
          'jwt': this.tempjwt
        }
      })
      .then(response => {
        let data = response.data
        this.liveCount = 0
        this.liveCount = data.length
      })
      .catch(err => {
        console.error(err)
      })
    }, 60000)
    if(!this.isShareSession){
    this.isBlurred =
      this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
      this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))
    }
    console.log('Analytics mounted')
    this.$auditlog({ module: 'usage', action: 'view_analytics' })  
      
    try{
      howuku.track('usage', { feature: 'view_analytics' })
    }catch(e){}

    try{
      _cio.track('usage', { feature: 'view_analytics', created_at: Math.round(new Date().getTime() / 1000) })
    }catch(e){}       
  },
  created() {
    for (let i = 1; i <= 10; i++) {
      if (this.$route.params['key' + i]) {
        let obj = {}
        obj[this.$route.params['key' + i]] = this.$route.params[
          'value' + i
        ].replace(/---/g, '/')
        this.filterCriteria.push(obj)
      }
    }
    document.addEventListener('resize', this.resizeChart)
    if (document.addEventListener) { window.addEventListener('resize', this.resizeChart) }
    if (document.attachEvent) window.attachEvent('onresize', this.resizeChart)

    console.log('Analytics created')
  },
  watch: {
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
        this.startDate = date.startDate
        this.endDate = date.endDate
        this.removeRouter('datetime')

        // Remove because remove router has loadstats in it
        // this.loadStats()
      },
      deep: true
    },
    '$store.getters.tab.analytics': {
      handler: function (x) {
        this.selectedTab = x
      }
    }
  },
  methods: {
    assignValuesForShare(){
      if(!this.$route.params.encryptedParam){
        this.tempjwt = localStorage.getItem('jwt')
        this.tempWidgetId = this.$session.get('widget_id')
      }else{
        this.isShareSession = true
        this.tempjwt = window.TEMP_JWT
        this.tempWidgetId = window.TEMP_WIDGET_ID
        this.$store.commit('setDatepicker', {
          module: 'dashboard',
          name: 'startDate',
          data: window.TEMP_START_DATE
        })
        this.$store.commit('setDatepicker', {
          module: 'dashboard',
          name: 'endDate',
          data: window.TEMP_END_DATE
        })
      }
    },
    setupRoute() {
      
      // this.filterCriteria(router)
      this.filterCriteria = this.$route.query
      // console.log(this.$route.query)
      // console.log(Object.keys(this.$route.query))
      // for (let i in this.$route.params) {
      //   console.log(123)
      //   console.log(i, this.$route.params[i])
      // }
    },
    estimatedDevice(resolution) {
      let wh = resolution.split('x'),
        w = Number(wh[0]),
        h = Number(wh[1]),
        ratio = w / h

      if (ratio > 1.2) return 'desktop'
      if (ratio < 0.6) return 'mobile-alt'
      return 'tablet-alt'
    },
    // downloadPdf() {
    //   if (
    //     this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
    //     this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))
    //   ) {
    //     this.$swal.fire({
    //       title: 'Premium Feature',
    //       text: 'You will need to upgrade you account to any of our paid plan to download analytics data.',
    //       type: 'warning',
    //       confirmButtonColor: '#2167f5'
    //     })
    //     return
    //   }
    //   var options = {
    //     labels: {
    //       success: ' '
    //     }
    //   }
    //   this.$awn.success('Processing. Please wait ...', {
    //     position: 'bottom-right',
    //     maxNotifications: 1,
    //     labels: options.labels
    //   })
    //   var jsPDF = require('jspdf')
    //   var html2canvas = require('html2canvas')

    //   let imgs = document.getElementsByTagName('img')

    //   for (let i = 0; i < imgs.length; i++) {
    //     imgs[i].src = 'https://api.mida.so/' + imgs[i].src
    //     imgs[i].setAttribute('crossOrigin', true)
    //   }

    //   this.limit.referrer += 200
    //   this.limit.destination += 200
    //   this.limit.country += 200
    //   this.limit.resolution += 200
    //   this.limit.device += 200
    //   this.limit.os += 200
    //   this.limit.browser += 200

    //   var listing = document.getElementsByClassName('listing')
    //   var btn = document.getElementsByClassName('listing')
    //   var scrollable = document.getElementsByClassName('scrollable')

    //   for (let i = 0; i < listing.length; i++) {
    //     listing[i].classList.add('noshadow')
    //   }

    //   for (let i = 0; i < btn.length; i++) {
    //     btn[i].classList.add('noshadow')
    //   }

    //   for (let i = 0; i < scrollable.length; i++) {
    //     scrollable[i].classList.remove('scrollable')
    //   }
    //   var offScreen =
    //     document.getElementsByClassName('container-fluid')[0].children[0]

    //   setTimeout(() => {
    //     html2canvas(offScreen, {
    //       logging: true,
    //       letterRendering: 1,
    //       allowTaint: false,
    //       useCORS: true,
    //       scale: 1
    //       // onrendered: function (canvas) {
    //       //   document.body.appendChild(canvas)
    //       //   document.body.removeChild(clone)
    //       // },
    //     }).then(function (canvas) {
    //       var imgData = canvas.toDataURL('image/png')
    //       var imgWidth = 210
    //       var pageHeight = 295
    //       var imgHeight = (canvas.height * imgWidth) / canvas.width
    //       var heightLeft = imgHeight
    //       var doc = new jsPDF('p', 'mm')
    //       var position = 10 // give some top padding to first page

    //       doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    //       heightLeft -= pageHeight

    //       while (heightLeft >= 0) {
    //         position = heightLeft - imgHeight // top padding for other pages
    //         doc.addPage()
    //         doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    //         heightLeft -= pageHeight
    //       }
    //       doc.save('feedback_report.pdf')

    //       for (let i = 0; i < listing.length; i++) {
    //         listing[i].classList.remove('noshadow')
    //       }

    //       for (let i = 0; i < btn.length; i++) {
    //         btn[i].classList.remove('noshadow')
    //       }

    //       for (let i = 0; i < scrollable.length; i++) {
    //         scrollable[i].classList.add('scrollable')
    //       }
    //     })
    //   }, 100)
    // },
    getPageview(x) {
      this.totalPageview = x
    },
    getObjKey(obj) {
      return Object.keys(obj)[0]
    },
    thousandFormat(x) {
      if (typeof x === 'number') x = x.toString()
      if (typeof x !== 'string') return x
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    removeRouter(key) {

      let query = Object.assign({}, this.$route.query);
      delete query[key];
      this.$router.replace({ query });

      this.key++
      setTimeout(() => {
        this.loadStats()
      }, 500);
    },
    getRouteValue(key) {
      let regexStr = new RegExp(key + '=([^&]*)')
      let matched = window.location.href.match(regexStr)

      if (!matched) return null
      return decodeURI(matched[1].toString().replace(/\-\-\-/g, '/'))
    },
    setRouter(key = null, value = null) {
      if (!key && !value) {
        if(!this.isShareSession){
          this.$router.push({ path: '/analytics/' })
        }else{
          this.$router.push({ path: '/share/analytics/' + this.$route.params.encryptedParam })
        }
      }
      else {
        // find if key existed
        for (let i = this.filterCriteria.length - 1; i >= 0; i--) {
          // if found. delete it and append to the end
          let okey = Object.keys(this.filterCriteria[i])[0]

          if (key === okey) {
            this.filterCriteria.splice(i, 1)
          }
        }

        let newobj = {}
        newobj[key] = value
        this.filterCriteria.push(newobj)

        // form new path
        let path=''
        if(!this.isShareSession){
           path = '/analytics'
        }else{
          path = '/share/analytics'
        }
        for (let i in this.filterCriteria) {
          let key = Object.keys(this.filterCriteria[i])[0]

          path +=
            '/' +
            key +
            '/' +
            this.filterCriteria[i][key].toString().replace(/\//g, '---')
        }
        this.key++
        if(!this.isShareSession) {
          this.$router.push({ path: path })
        }else{
          this.$router.push({path: path +'/' +this.$route.params.encryptedParam})
        }
        this.key++
      }
    },
    setUrlParam(obj) {
      // console.log(this.$route.query)

      var query = { ...this.$route.query, ...obj }
      // if (this.$route.query.url) this.pagelocation = this.$route.query.url // read parameter
      //  this.setUrlParam({ landing_page: "www.howuku.com", ref_page: "123" }) // set parameter
      this.$router.replace({ query })
      // if (this.$route.query.url) this.pagelocation = this.$route.query.url
    },    
    showAll() {
      this.url = null
      this.$router.replace({});
    },
    showCountry(x) {
      this.url = null
      this.setUrlParam({'country': x})
    },
    showCity(x) {
      this.url = null
      this.setUrlParam({'city': x})
    },
    showResolution(x) {
      this.url = null
      this.setUrlParam({'resolution': x})
    },
    showBrowser(x) {
      this.url = null
      this.setUrlParam({'browser': x})
    },
    showOS(x) {
      this.url = null
      this.setUrlParam({'os': x})
    },
    showDevice(x) {
      this.url = null
      this.setUrlParam({'device': x})
    },
    showRefs(x) {
      this.setUrlParam({'referrer': x})
    },
    showUtm(key, value) {
      let obj = {}
      obj[key] = value
      this.setUrlParam(obj)
    },    
    showUrl(x) {
      this.setUrlParam({'url': x.toString().replace(/\//g, '---')})
    },
    triggerTime(time) {
      this.setRouter('datetime', time)
    },
    abs(n) {
      return Math.abs(n)
    },
    comparePrevious(c, p) {
      let diff = c / p
      let percent = this.precisionRound((diff - 1) * 100, 0)
      return percent
    },
    conceal(str) {
      if (this.isBlurred) {
        str = str.replace(/./g, 'a')
      }
      return str
    },
    processReferrer(ref, url) {
      let originalRef = ref

      if (ref === undefined) return ref
      ref = ref.toLowerCase()
      // if (/twclid/.test(ref)) return 'Twitter Ads'
      // if (/googleads.g.doubleclick.net/.test(ref) || /gclid/.test(url)) {
      //   return 'Google Ads'
      // }
      // if (/google.com/.test(ref)) {
      //   return 'Google'
      // }
      // if (/reddit/.test(ref)) {
      //   return 'Reddit'
      // }
      // if (/facebook/.test(ref) || /fbclid/.test(url)) {
      //   return 'Facebook'
      // }
      // if (/quora/.test(ref)) {
      //   return 'Quora'
      // }
      // if (/indiehacker/.test(ref)) {
      //   return 'Indiehacker'
      // }
      // if (/t.co\//.test(ref)) {
      //   return 'Twitter'
      // }
      // if (/linkedin/.test(ref)) {
      //   return 'Linkedin'
      // }
      // if (/betalist/.test(ref)) {
      //   return 'Betalist'
      // }
      // if (/betapage/.test(ref)) {
      //   return 'Betapage'
      // }
      // if (/producthunt/.test(ref)) {
      //   return 'ProductHunt'
      // }
      // if (/linkedin/.test(ref)) {
      //   return 'Linkedin'
      // }
      if (ref === '') {
        return 'Direct'
      }
      return this.removeProtocol(originalRef)
    },
    formatit(date) {
      let m = moment(date)
      let iscurrentDate = m.isSame(new Date(), 'day')
      if (iscurrentDate) return m.fromNow()
      return m.format('DD MMM')
    },
    removeDomain: function (text) {
      return (
        '/' +
        text.split('/')[3] +
        (text.split('/')[4] ? '/' + text.split('/')[4] : '') +
        (text.split('/')[5] ? '/' + text.split('/')[5] : '')
      )
    },
    getDomain: function (text) {
      let domain = text.replace(/^https?\:\/\//, '')
      let domainparts = domain.split('/')
      return (
        domainparts[0] +
        '/' +
        (domainparts[1] || '') +
        (domainparts[2] ? '---' + domainparts[2] : '') +
        (domainparts[3] ? '---' + domainparts[3] : '')
      )
    },
    removeProtocol: function (text) {
      if (!text) return text
      text = text.replace(/^https:\/\//g, '')
      text = text.replace(/^http:\/\//g, '')
      text = text.replace(/^www\./g, '')
      text = text.split('/')[0]

      if (text === '') return 'direct'
      return text
    },
    shorten(string, len) {
      if (!string) return string

      if (string.length > len) return string.substring(0, len) + '...'
      else return string
    },
    mapValue(k, v) {
      if (k === 'device') {
        return Number(v) === 1
          ? 'Desktop'
          : Number(v) === 2
            ? 'Mobile'
            : 'Tablet'
      }
      return v.replace(/---/g, '/')
    },
    precisionRound: function (number, precision) {
      var factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    },
    loadTop: function (criteria, result) {
      let data = result
      let max = 0

      if (criteria === 'referrer') {
        let result = {}
        for (let i = 0; i < data.length; i++) {
          console.log(`referrer: ${data[i].referrer}, url: ${data[i].url}, count: ${data[i].count}`)
          console.log(data[i])
          let r = this.processReferrer(data[i].referrer, data[i].url)
          if (result[r]) {
            result[r].count += data[i].count
            result[r].links.push(data[i].referrer)
          } else {
            result[r] = {
              links: data[i].referrer ? [data[i].referrer] : [],
              referrer: this.processReferrer(data[i].referrer, data[i].url),
              count: data[i].count,
              link: this.removeProtocol(data[i].referrer)
            }
          }
        }
        let newData = []
        for (let i in result) {
          newData.push(result[i])
        }
        var final = newData.slice(0)
        final.sort(function (a, b) {
          return b.count - a.count
        })

        data = final
      } else if (criteria === 'destination') {
        let result = {}
        // removeDomain

        // check if there is another domain
        let lastDestination = null
        let multipleDomain = false
        for (let i = 0; i < data.length; i++) {
          if (
            lastDestination &&
            data[i].destination &&
            lastDestination !==
              data[i].destination
                .replace(/^http(s)?\:\/\/(www.)?/, '')
                .split('/')[0]
          ) {
            multipleDomain = true
            break
          }

          if (data[i].destination) {
            lastDestination = data[i].destination
              .replace(/^http(s)?\:\/\/(www.)?/, '')
              .split('/')[0]
          }
        }

        for (let i = 0; i < data.length; i++) {
          if (data[i].destination.includes('api.mida.so/load/')) continue
          let r = data[i].destination.split('?')[0].split('#')[0]

          if (multipleDomain) {
          } else {
            r =
              r.split('/')[3] +
              (r.split('/')[4] ? '/' + r.split('/')[4] : '') +
              (r.split('/')[5] ? '/' + r.split('/')[5] : '')
          }

          if (result[r]) result[r].count += data[i].count
          else {
            let url = data[i].destination
              .split('?')[0]
              .split('#')[0]
              .replace(/^http(s)?\:\/\/(www.)?/, '')
            result[r] = {
              destination: url,
              destinationDisplay: multipleDomain
                ? url
                : this.removeDomain(
                  data[i].destination.split('?')[0].split('#')[0]
                ),
              count: data[i].count
            }
          }
        }
        let newData = []
        for (let i in result) {
          newData.push(result[i])
        }
        var final = newData.slice(0)
        final.sort(function (a, b) {
          return b.count - a.count
        })

        data = final
      } else if (criteria.startsWith('utm_')) {

        let key = criteria.split('utm_')[1]
        let result = {}
        let regexStr = new RegExp('utm_' + key + '=([^&]*)')

        for (let i = 0; i < data.length; i++) {
          let utm = data[i].destination.match(regexStr)
          if (!utm) continue
          let r = utm[1]

          if (result[r]) result[r].count += data[i].count
          else {
            let obj = {}
            obj['utm_' + key] = r
            obj.count = data[i].count
            result[r] = obj
          }
        }
        let newData = []
        for (let i in result) {
          newData.push(result[i])
        }
        var final = newData.slice(0)
        final.sort(function (a, b) {
          return b.count - a.count
        })

        data = final
      } else if (criteria === 'entry') {
        let result = {}
        // removeDomain

        // check if there is another domain
        let lastentry = null
        let multipleDomain = false
        for (let i = 0; i < data.length; i++) {
          if (
            lastentry &&
            lastentry !==
              data[i].entry.replace(/^http(s)?\:\/\/(www.)?/, '').split('/')[0]
          ) {
            multipleDomain = true
            break
          }
          lastentry = data[i].entry
            .replace(/^http(s)?\:\/\/(www.)?/, '')
            .split('/')[0]
        }

        for (let i = 0; i < data.length; i++) {
          if (data[i].entry.includes('api.mida.so/load/')) continue
          let r = data[i].entry.split('?')[0].split('#')[0]

          if (multipleDomain) {
          } else {
            r =
              r.split('/')[3] +
              (r.split('/')[4] ? '/' + r.split('/')[4] : '') +
              (r.split('/')[5] ? '/' + r.split('/')[5] : '')
          }

          if (result[r]) result[r].count += data[i].count
          else {
            let url = data[i].entry
              .split('?')[0]
              .split('#')[0]
              .replace(/^http(s)?\:\/\/(www.)?/, '')
            result[r] = {
              entry: url,
              entryDisplay: multipleDomain
                ? url
                : this.removeDomain(data[i].entry.split('?')[0].split('#')[0]),
              count: data[i].count
            }
          }
        }
        let newData = []
        for (let i in result) {
          newData.push(result[i])
        }
        var final = newData.slice(0)
        final.sort(function (a, b) {
          return b.count - a.count
        })

        data = final
      } else if (criteria === 'exit') {
        let result = {}

        // check if there is another domain
        let lastexit = null
        let multipleDomain = false
        for (let i = 0; i < data.length; i++) {
          if (
            lastexit &&
            lastexit !==
              data[i].exit.replace(/^http(s)?\:\/\/(www.)?/, '').split('/')[0]
          ) {
            multipleDomain = true
            break
          }
          lastexit = data[i].exit
            .replace(/^http(s)?\:\/\/(www.)?/, '')
            .split('/')[0]
        }

        for (let i = 0; i < data.length; i++) {
          if (data[i].exit.includes('api.mida.so/load/')) continue
          let r = data[i].exit.split('?')[0].split('#')[0]

          if (multipleDomain) {
          } else {
            r =
              r.split('/')[3] +
              (r.split('/')[4] ? '/' + r.split('/')[4] : '') +
              (r.split('/')[5] ? '/' + r.split('/')[5] : '')
          }

          if (result[r]) result[r].count += data[i].count
          else {
            let url = data[i].exit
              .split('?')[0]
              .split('#')[0]
              .replace(/^http(s)?\:\/\/(www.)?/, '')
            result[r] = {
              exit: url,
              exitDisplay: multipleDomain
                ? url
                : this.removeDomain(data[i].exit.split('?')[0].split('#')[0]),
              count: data[i].count
            }
          }
        }
        let newData = []
        for (let i in result) {
          newData.push(result[i])
        }
        var final = newData.slice(0)
        final.sort(function (a, b) {
          return b.count - a.count
        })

        data = final
      } else if (criteria === 'country') {
        let result = {}
        for (let i = 0; i < data.length; i++) {
          let r = data[i].country

          if (result[r]) result[r].count += data[i].count
          else if (data[i].country) {
            result[r] = {
              country_code: data[i].country_code,
              country: data[i].country,
              count: data[i].count
            }
          }
        }
        let newData = []
        for (let i in result) {
          newData.push(result[i])
        }
        var final = newData.slice(0)
        final.sort(function (a, b) {
          return b.count - a.count
        })

        data = final
      } else if (criteria === 'city') {
        let result = {}
        for (let i = 0; i < data.length; i++) {
          let r = data[i].city

          if (result[r]) result[r].count += data[i].count
          else if (data[i].city) {
            result[r] = {
              country_code: data[i].country_code,
              city: data[i].city,
              count: data[i].count
            }
          }
        }
        let newData = []
        for (let i in result) {
          newData.push(result[i])
        }
        var final = newData.slice(0)
        final.sort(function (a, b) {
          return b.count - a.count
        })

        data = final
      } else {
        let result = {}
        for (let i = 0; i < data.length; i++) {
          let r = data[i][criteria] || 'Unknown'

          if (result[r]) result[r].count += data[i].count
          else {
            result[r] = {
              count: data[i].count
            }

            result[r][criteria] = r
          }
        }
        let newData = []
        for (let i in result) {
          newData.push(result[i])
        }
        var final = newData.slice(0)
        final.sort(function (a, b) {
          return b.count - a.count
        })

        data = final
      }

      for (let i = 0; i < data.length; i++) {
        if (i === 0) max = data[i].count

        data[i].bar = (data[i].count / max) * 100
      }
      this.top[criteria] = data
      this.statsRefresh++
    },
    leadingZero: function (num) {
      return ('0' + num).slice(-2)
    },
    secondsToTime: function (secs) {
      return secs <= 0 || !secs
        ? '0s'
        : secs > 60
          ? ~~((secs % 3600) / 60) + 'm ' + (~~secs % 60) + 's'
          : ~~secs + 's'
    },
    shortNumber(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + 'K'
        : Math.sign(num) * Math.abs(num)
    },
    getLiveVisitorId() {
      this.liveVisitorIds = []
      for (let i = 0; i < this.liveData.length; i++) {
        this.liveVisitorIds.push(this.liveData[i].visitor_id)
      }      
    },
    loadPrevious() {
      let url = ''
      let browser = ''
      let os = ''
      let resolution = ''
      let utm_source = ''
      let utm_campaign = ''
      let utm_medium = ''
      let utm_term = ''         
      let device = ''
      let referrer = ''
      let country = ''
      let specificTime = ''
      var startDate = this.$store.getters.datepicker.dashboard.startDate
      var endDate = this.$store.getters.datepicker.dashboard.endDate

      if (!endDate) {
        startDate = moment(
          this.$store.getters.datepicker.dashboard.startDate ||
            this.$userTimeNow().toISOString().substring(0, 10)
        )
          .add('day', -1)
          .format('YYYY-MM-DD')
        this.previousInterval = 0
      } else {
        var a = moment(startDate)
        var b = moment(endDate)
        this.previousInterval = a.diff(b, 'days')
        startDate = moment(
          this.$store.getters.datepicker.dashboard.startDate ||
            this.$userTimeNow().toISOString().substring(0, 10)
        )
          .add('day', this.previousInterval)
          .format('YYYY-MM-DD')
        endDate = moment(this.$store.getters.datepicker.dashboard.endDate)
          .add('day', this.previousInterval)
          .format('YYYY-MM-DD')
      }

      referrer = this.getRouteValue('referrer')
      country = this.getRouteValue('country')
      url = this.getRouteValue('url')
      device = this.getRouteValue('device')
      browser = this.getRouteValue('browser')
      resolution = this.getRouteValue('resolution')
      utm_source = this.getRouteValue('utm_source')
      utm_campaign = this.getRouteValue('utm_campaign')
      utm_medium = this.getRouteValue('utm_medium')
      utm_term = this.getRouteValue('utm_term')
      os = this.getRouteValue('os')
      let datetime = this.getRouteValue('datetime')
      if (datetime) {
        specificTime = 1
        if (datetime.includes('PM') || datetime.includes('AM')) {
          let hour = Number(datetime.replace(/\D/g, ''))
          if (datetime.includes('PM')) hour += 12
          if (startDate === '' || startDate === null) {
            var today = new Date()
            var dd = String(today.getDate()).padStart(2, '0')
            var mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
            var yyyy = today.getFullYear()

            startDate = yyyy + '-' + mm + '-' + dd
          }
          endDate = startDate + ' ' + hour + ':59:59'
          startDate += ' ' + hour + ':00:00'
        } else {
          let convertedDate = moment(datetime).calendar().toString()
          let p = convertedDate.split('/')
          let month = p[0]
          let day = p[1]
          let today = new Date()
          let yyyy = today.getFullYear()
          let date = yyyy + '-' + month + '-' + day
          startDate = date + ' 00:00:00'
          endDate = date + ' 23:59:59'
        }
      }

      this.$http
        .post(process.env.API_ENDPOINT + '/tracking/rawPrevious-ch', {
          widget_id: (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId,
          startDate: startDate,
          endDate: endDate,
          url: url,
          referrer: referrer,
          country: country,
          browser: browser,
          os: os,
          resolution: resolution,
          utm_source: utm_source,
          utm_campaign: utm_campaign,
          utm_medium: utm_medium,
          utm_term: utm_term,          
          device: device,
          specificTime: specificTime,
        },{
          headers: {
            'jwt': this.tempjwt
          }
        })
        .then((response) => {
          let data = response.data
          this.previouscount = 0
          this.previousunique = 0
          this.previouspps = 0
          this.chartDataPrevious = data.pageview
          // console.log('previous', data.pageview)

          // page view
          for (let i = 0; i < data.pageview.length; i++) {
            this.previouscount += data.pageview[i].count
          }

          this.previouscount = this.comparePrevious(
            this.pageview.count,
            this.previouscount
          )

          // unique
          for (let i = 0; i < data.unique.length; i++) {
            this.previousunique += data.unique[i].count
          }
          this.previousunique = this.comparePrevious(
            this.pageview.unique,
            this.previousunique
          )

          // pages per session
          this.previouspps = this.comparePrevious(
            this.pageview.count/this.pageview.unique,
            this.previouscount/this.previousunique
          )

          // bounce
          this.previousbounce = this.precisionRound(
            data.bounce[0].bounce_rate * 100,
            2
          )
          this.previousbounce = this.comparePrevious(
            this.bounce,
            this.previousbounce
          )

          let pvpv = this.pageview.count / this.pageview.unique

          // session time
          this.previousrawSessionTime = data.sessionTime[0].avg_sess_time * pvpv
          this.previousrawSessionTime = this.comparePrevious(
            this.pageview.rawSessionTime,
            this.previousrawSessionTime
          )
          
          this.key++


          this.previousIsLoaded = true
        })
    },
    loadStats: function () {
      this.isLoaded = false
      this.previousIsLoaded = false

      this.pageview = {
        count: 0,
        visitor: 0,
        unique: 0
      }
      this.bounce = 0
      this.sessionTime = 0
      this.showChart = false
      this.specificTime = 0

      let url = ''
      let referrer = ''
      let country = ''
      let browser = ''
      let os = ''
      let resolution = ''
      let utm_source = ''
      let utm_campaign = ''
      let utm_medium = ''
      let utm_term = ''      
      let device = ''
      let specificTime = ''
      var startDate = this.$store.getters.datepicker.dashboard.startDate
      var endDate = this.$store.getters.datepicker.dashboard.endDate
      
      this.$http.get(process.env.API_ENDPOINT + '/current/live',{        
        headers: {
          'jwt': this.tempjwt
        }})
      .then(response => {
        let data = response.data
        this.liveCount = 0
        this.liveCount = data.length
        this.liveData = data
        this.liveVisitorIds = []
        for (let i = 0; i < this.liveData.length; i++) {
          this.liveVisitorIds.push(this.liveData[i].visitor_id)
        }              
      })
      .catch(err => {
        console.error(err)
      }) 

      referrer = this.getRouteValue('referrer')
      country = this.getRouteValue('country')
      url = this.getRouteValue('url')
      device = this.getRouteValue('device')
      browser = this.getRouteValue('browser')
      resolution = this.getRouteValue('resolution')
      utm_source = this.getRouteValue('utm_source')
      utm_campaign = this.getRouteValue('utm_campaign')
      utm_medium = this.getRouteValue('utm_medium')
      utm_term = this.getRouteValue('utm_term')
      os = this.getRouteValue('os')
      let datetime = this.getRouteValue('datetime')
      if (datetime) {
        specificTime = 1
        if (datetime.includes('PM') || datetime.includes('AM')) {
          let hour = Number(datetime.replace(/\D/g, ''))
          if (datetime.includes('PM')) hour += 12
          if (startDate === '' || startDate === null) {
            var today = new Date()
            var dd = String(today.getDate()).padStart(2, '0')
            var mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
            var yyyy = today.getFullYear()

            startDate = yyyy + '-' + mm + '-' + dd
          }
          endDate = startDate + ' ' + hour + ':59:59'
          startDate += ' ' + hour + ':00:00'
        } else {
          let convertedDate = moment(datetime).calendar().toString()
          let p = convertedDate.split('/')
          let month = p[0]
          let day = p[1]
          let today = new Date()
          let yyyy = today.getFullYear()
          let date = yyyy + '-' + month + '-' + day
          startDate = date + ' 00:00:00'
          endDate = date + ' 23:59:59'
        }
      }

      // axios
      //   .post(process.env.API_ENDPOINT + '/tracking/raw', {
      //     widget_id: this.$session.get('widget_id'),
      //     startDate: startDate,
      //     endDate: endDate,
      //     url: url,
      //     referrer: referrer,
      //     country: country,
      //     browser: browser,
      //     os: os,
      //     resolution: resolution,
      //     device: device,
      //     specificTime: specificTime,
      //   })
      //   .then((response) => {
      //     console.log('raw')
      //     console.log(response.data)
      //   })

      if (!this.statInProgress) {
        this.statInProgress = true
      this.$http
        .post(process.env.API_ENDPOINT + '/tracking/raw-ch', {
          widget_id: (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId,
          startDate: startDate,
          endDate: endDate,
          url: url,
          referrer: referrer,
          country: country,
          browser: browser,
          os: os,
          resolution: resolution,
          utm_source: utm_source,
          utm_campaign: utm_campaign,
          utm_medium: utm_medium,
          utm_term: utm_term,
          device: device,
          specificTime: specificTime,
        },{
          headers: {
          'jwt': this.tempjwt
        }
        })
        .then((response) => {
          this.loadPrevious()
          this.statInProgress = false

          let data = response.data
          this.totalPageViewManual = 0

          this.showChart = true
          this.pageview['count'] = 0
          this.pageview['unique'] = 0

          this.chartData = data.pageview
          console.log('current', data.pageview)

          this.tz = localStorage.getItem('Tz')
          // page view
          for (let i = 0; i < data.pageview.length; i++) {
            this.pageview['count'] += data.pageview[i].count
            this.noData = false
          }

          this.visitorIds = []

          // unique
          for (let i = 0; i < data.unique.length; i++) {
            this.pageview['unique'] += data.unique[i].count
            this.visitorIds.push(data.unique[i].visitor_id)
          }

          // bounce
          this.bounce = this.precisionRound(data.bounce[0].bounce_rate * 100, 2)

          let pvpv = this.pageview.count / this.pageview.unique

          // session time
          this.pageview.rawSessionTime =
            data.sessionTime[0].avg_sess_time * pvpv
          this.sessionTime = this.secondsToTime(
            data.sessionTime[0].avg_sess_time * pvpv
          )

          // top
          this.loadTop('destination', data.top_destination)
          this.loadTop('utm_source', data.top_destination)
          this.loadTop('utm_campaign', data.top_destination)
          this.loadTop('utm_medium', data.top_destination)
          this.loadTop('utm_term', data.top_destination)
          this.loadTop('entry', data.top_entry)
          this.loadTop('exit', data.top_exit)
          this.loadTop('referrer', data.top_referrer)
          this.loadTop('country', data.top_country)
          this.loadTop('city', data.top_city)
          this.loadTop('resolution', data.top_resolution)
          this.loadTop('device', data.top_device)
          this.loadTop('browser', data.top_browser)
          this.loadTop('os', data.top_os)

          for (let i = 0; i < this.top.destination.length; i++) {
            this.totalPageViewManual += this.top.destination[i].count
          }

          this.key++

          this.isLoaded = true
        }).catch(e => { this.statInProgress = false })
      }
    },
    exportCsv() {
      if (
        this.$isFreePlan.includes(this.$session.get('paid_plan')) ||
        this.$isLegacyFreePlan.includes(this.$session.get('paid_plan'))
      ) {
        this.$swal.fire({
          title: 'Upgrade your plan',
          text: 'This is a paid feature. Upgrade plan to access more features.',
          type: 'warning',
          confirmButtonColor: '#2167f5'
        })
        return
      }
      var stats = []
      var chart = []
      var visits = []
      let data1 = []
      let data2 = []
      let data3 = []
      let data4 = []
      let data5 = []
      let data6 = []

      stats.push(
        [
          '"Unique_visit_count"',
          '"Pageviews_count"',
          '"Visit_duration_count"',
          '"Bounce_rate_count"'
        ].join(';')
      )

      data1.push('"' + this.pageview['unique'] + '"')
      data1.push('"' + this.pageview['count'] + '"')
      data1.push('"' + this.sessionTime + '"')
      data1.push('"' + this.bounce + '"')
      stats.push(data1.join(';'))
      chart.push(['"Time_of_day"', '"Pageviews_count"'].join(';'))

      for (let i = 0; i < this.chartData.length; i++) {
        let time = 12
        let format = 'AM'
        if (this.chartData[i].date > time) {
          time = this.chartData[i].date - time
          format = 'PM'
        } else if (this.chartData[i].date < time) {
          if (Number(this.chartData[i].date) === 0) {
            time = time
          } else time = this.chartData[i].date
        } else if ((this.chartData[i].date = time)) {
          format = 'PM'
        }
        data2.push(
          '"' + time + format + '"' + ';"' + this.chartData[i].count + '"'
        )
      }
      for (let i = 0; i < data2.length; i++) {
        chart.push(data2[i])
      }

      data3.push('Referrer')
      data4.push('Top_pages')
      data5.push('Top_visited_country')
      data6.push('Device')

      for (let i = 0; i < this.top['referrer'].length; i++) {
        data3.push(
          '"' +
            this.top['referrer'][i].referrer +
            '"' +
            ';"' +
            this.top['referrer'][i].count +
            '"'
        )
      }
      for (let i = 0; i < this.top['destination'].length; i++) {
        data4.push(
          '"' +
            this.top['destination'][i].destination +
            '"' +
            ';"' +
            this.top['destination'][i].count +
            '"'
        )
      }
      for (let i = 0; i < this.top['country'].length; i++) {
        data5.push(
          '"' +
            this.top['country'][i].country +
            '"' +
            ';"' +
            this.top['country'][i].count +
            '"'
        )
      }
      for (let i = 0; i < this.top['device'].length; i++) {
        let device = 'Desktop'
        if (this.top['device'][i].device === 2) device = 'Mobile' || 'Tablet'
        data6.push(
          '"' + device + '"' + ';"' + this.top['device'][i].count + '"'
        )
      }

      let array = [data3, data4, data5, data6]
      let csv_list = []
      array = array.sort(function (a, b) {
        return b.length - a.length
      })
      for (let i = 1; i < array[0].length; i++) {
        csv_list[i] = array[0][i]
      }
      csv_list = csv_list.map((e, i) => {
        return (e + ';' + array[1][i]).replace('undefined', '__')
      })
      csv_list = csv_list.map((e, i) => {
        return (e + ';' + array[2][i]).replace('undefined', '__')
      })
      csv_list = csv_list.map((e, i) => {
        return (e + ';' + array[3][i]).replace('undefined', '__')
      })
      visits.push(
        [
          array[0][0],
          array[0][0] + '_count',
          array[1][0],
          array[1][0] + '_count',
          array[2][0],
          array[2][0] + '_count',
          array[3][0],
          array[3][0] + '_count'
        ].join(';')
      )
      console.log(csv_list)
      for (let i = 1; i < csv_list.length; i++) {
        visits.push(csv_list[i])
      }

      // // console.log(csv)
      var stats_string = stats.join('\n')
      var filename =
        'analytics stats_' + new Date().toLocaleDateString() + '.csv'
      var link = document.createElement('a')
      link.style.display = 'none'
      link.setAttribute('target', '_blank')
      link.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' + encodeURIComponent(stats_string)
      )
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      var chart_string = chart.join('\n')
      var filename =
        'analytics pageview chart_' + new Date().toLocaleDateString() + '.csv'
      var link = document.createElement('a')
      link.style.display = 'none'
      link.setAttribute('target', '_blank')
      link.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' + encodeURIComponent(chart_string)
      )
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      var visits_string = visits.join('\n')
      var filename =
        'analytics visits_' + new Date().toLocaleDateString() + '.csv'
      var link = document.createElement('a')
      link.style.display = 'none'
      link.setAttribute('target', '_blank')
      link.setAttribute(
        'href',
        'data:text/csv;charset=utf-8,' + encodeURIComponent(visits_string)
      )
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    openShareLinkSettings(){
      this.$modal.show('show-shareSettings')
    },
    checkForFlag(){
        this.$http.get(process.env.API_ENDPOINT + '/sharePermission',{
            headers:{
            'company_id':this.$session.get('company_id'),
            'widget_id':this.$session.get('widget_id')
            }
        }).then(result =>{
            console.log((result.data))
            for (let index = 0; index < result.data.length; index++) {
                const element = result.data[index];
                console.log(element.modules === this.$route.name)
                if(element.modules === this.$route.name){
                    this.isPublicShare = (element.flag===0) ? true:false
                    console.log(this.isPublicShare)
                }
            }
        })
    },
  }
}
</script>
<style>
.progress-mini {
  height: 0.3rem !important;
}

.progress-bar {
  background-color: #136bf6;
}

.hyperlink {
  color: var(--color-muted);
}

.hyperlink:hover {
  color: var(--color-muted-hover);
}

.fixed-200h canvas {
  width: auto;
  max-height: 400px;
}

.ipinfo-tbody td {
  white-space: nowrap;
  overflow: hidden;
}

.mh-400 {
  min-height: 520px;
}

.mh-400-2 {
  min-height: 380px;
}

.alive-dot {
  width: 12px;
  display: inline-block;
  height: 12px;
  font-size: 0;
  background-color: #3fd43f;
  border: 0;
  border-radius: 35px;
  outline: none;
  cursor: pointer;
}
/* 
.chart-type.active, .chart-type:hover {
  background-color: #eceff1;
} */

.chart-type {
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: 300;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Analytics.vue